<template>
  <!-- <img src="@/assets/img/community_banner.jpg" class="w-full max-h-[25rem] min-h-[11.25rem] object-cover" /> -->

  <main
    class="main w-full max-w-[82.75rem] mx-auto mt-14 px-4 sm:px-6 lg:px-8 mb-20 py-10"
  >
    <div
      class="bg-white rounded-lg shadow-sm border border-gray-200 p-6 sm:p-8"
    >
      <div class="flex flex-col gap-6 mb-8">
        <!-- Board Select & Title Input -->
        <div class="flex flex-col sm:flex-row gap-4">
          <select
            v-model="state.post.boardId"
            :disabled="state.post.postId !== null"
            class="form-select w-full sm:w-48 border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 text-sm"
          >
            <option value="null" disabled hidden>게시판 선택</option>
            <option
              v-for="boardList in boardLists"
              :key="boardList.id"
              :value="boardList.id"
            >
              {{ boardList.name }}
            </option>
          </select>
          <input
            type="text"
            placeholder="제목을 입력해 주세요."
            v-model="state.post.postTitle"
            class="form-input w-full flex-grow border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 text-sm"
          />
        </div>

        <!-- Options & Thumbnail -->
        <div
          class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 border-t border-b border-gray-100 py-4"
        >
          <!-- 썸네일 등록 -->
          <div class="flex items-center gap-4">
            <div class="flex items-center gap-3">
              <div
                id="imagePreview"
                class="relative w-16 h-16 border border-gray-200 rounded-md overflow-hidden bg-gray-50 flex items-center justify-center"
              >
                <img
                  :src="
                    'https://eduwind-api.nodeblack.net/' +
                    state.post.postThumbnail
                  "
                  v-if="state.post.postThumbnail"
                  class="w-full h-full object-cover"
                />
                <img
                  id="img"
                  v-else
                  class="w-full h-full object-cover hidden"
                />
                <svg
                  v-if="!state.post.postThumbnail"
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6 text-gray-300"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                  />
                </svg>
              </div>
              <div class="flex flex-col gap-1">
                <label
                  class="cursor-pointer inline-flex items-center px-3 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none"
                >
                  썸네일 등록
                  <input
                    id="thumbnailFile"
                    type="file"
                    @change="readInputFile"
                    class="hidden"
                  />
                </label>
                <button
                  v-if="state.post.postThumbnail || state.post.boardId == 4"
                  type="button"
                  @click="clearThumbnail"
                  class="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded text-red-600 hover:bg-red-50 focus:outline-none"
                >
                  삭제
                </button>
              </div>
            </div>

            <!-- 이미 등록된 썸네일 지우기 (웹진 아닐 때 로직 확인 필요하지만 기존 로직 유지) -->
            <!--
            <div v-else-if="state.post.postThumbnail && state.delToggle === false">
              <label class="cursor-pointer inline-flex items-center px-3 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none">
                <input type="checkbox" v-model="state.delToggle" class="hidden" />
                  썸네일 삭제
              </label>
            </div>
            -->
          </div>

          <div class="flex items-center gap-6">
            <label class="inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                v-model="state.post.isSecret"
                class="form-checkbox h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
              />
              <span class="ml-2 text-sm text-gray-700">비밀글</span>
            </label>

            <label
              class="inline-flex items-center cursor-pointer"
              v-if="$store.state.level.id === 10"
            >
              <input
                type="checkbox"
                v-model="state.post.isPin"
                class="form-checkbox h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
              />
              <span class="ml-2 text-sm text-gray-700">상단 고정</span>
            </label>
          </div>
        </div>
      </div>

      <div class="min-h-[500px]">
        <quillEditor
          v-model:value="state.post.postContent"
          contentType="html"
          toolbar="full"
          style="min-height: 500px"
          :options="editor.editorOption"
          :modules="modules"
        />
      </div>

      <!-- 첨부 파일 등록 부분 -->
      <div class="mt-6">
        <div class="flex items-center justify-between mb-2">
          <label class="block text-sm font-medium text-gray-700"
            >첨부파일 (최대 5개)</label
          >
          <span class="text-sm text-gray-500"
            >{{ state.attachments.length }}/5</span
          >
        </div>

        <!-- 파일 업로드 버튼 -->
        <div class="mb-3" v-if="state.attachments.length < 5">
          <label
            class="cursor-pointer inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
              />
            </svg>
            파일 첨부
            <input
              type="file"
              @change="addAttachment"
              class="hidden"
              multiple
              accept=".pdf,.xls,.xlsx,.ppt,.pptx,.hwp,.hwpx,.doc,.docx,.zip,.jpg,.jpeg,.png,.gif"
            />
          </label>
          <span class="ml-3 text-xs text-gray-500">파일당 최대 10MB</span>
        </div>

        <!-- 첨부파일 목록 -->
        <div
          v-if="state.attachments.length > 0"
          class="border border-gray-200 rounded-md divide-y divide-gray-200"
        >
          <div
            v-for="(attachment, index) in state.attachments"
            :key="index"
            class="flex items-center justify-between px-4 py-3 hover:bg-gray-50"
          >
            <div class="flex items-center min-w-0 flex-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 text-gray-400 mr-3 flex-shrink-0"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
              <div class="min-w-0 flex-1">
                <div class="flex items-center gap-2">
                  <p class="text-sm font-medium text-gray-900 truncate">
                    {{ attachment.name }}
                  </p>
                  <span
                    v-if="attachment.isNew"
                    class="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800"
                    >신규</span
                  >
                  <span
                    v-else
                    class="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-600"
                    >기존</span
                  >
                </div>
                <p class="text-xs text-gray-500">
                  {{ formatFileSize(attachment.size) }}
                </p>
              </div>
            </div>
            <div class="flex items-center gap-2 ml-4">
              <!-- 기존 첨부파일 다운로드 버튼 -->
              <a
                v-if="!attachment.isNew && attachment.url"
                :href="'https://eduwind-api.nodeblack.net' + attachment.url"
                target="_blank"
                class="text-blue-500 hover:text-blue-700 focus:outline-none"
                title="다운로드"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                  />
                </svg>
              </a>
              <!-- 삭제 버튼 -->
              <button
                type="button"
                @click="removeAttachment(index)"
                class="text-red-500 hover:text-red-700 focus:outline-none"
                title="삭제"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <!-- 첨부파일 없을 때 안내 -->
        <div
          v-else
          class="border border-dashed border-gray-300 rounded-md p-6 text-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="mx-auto h-10 w-10 text-gray-300"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
            />
          </svg>
          <p class="mt-2 text-sm text-gray-500">첨부할 파일을 선택해 주세요.</p>
        </div>
      </div>

      <!-- 태그 입력 부분  -->
      <div class="mt-6">
        <label class="block text-sm font-medium text-gray-700 mb-2">태그</label>
        <div
          class="flex flex-wrap items-center gap-2 p-2 border border-gray-300 rounded-md bg-white focus-within:ring-1 focus-within:ring-blue-500 focus-within:border-blue-500"
        >
          <div
            v-for="(tag, index) in state.post.postTags"
            :key="index"
            class="flex items-center bg-blue-50 text-blue-700 px-2 py-1 rounded-md text-sm"
          >
            <span>#{{ tag }}</span>
            <button
              type="button"
              @click="removeTag(index)"
              class="ml-1 text-blue-400 hover:text-blue-600 focus:outline-none"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-3 w-3"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
          </div>
          <input
            v-model="tagInput"
            @keydown.enter.prevent="addTag"
            @keydown.backspace="handleBackspace"
            type="text"
            placeholder="태그를 입력하고 엔터를 누르세요"
            class="flex-grow border-none focus:ring-0 text-sm min-w-[150px]"
          />
        </div>
      </div>
    </div>

    <div class="mx-auto my-10 flex justify-center items-center gap-3">
      <button
        type="button"
        class="px-8 py-3 bg-blue-600 text-white text-lg font-medium rounded-md hover:bg-blue-700 transition-colors shadow-sm"
        @click="postCreate"
      >
        작성 완료
      </button>
      <button
        type="button"
        class="px-8 py-3 bg-white border border-gray-300 text-gray-700 text-lg font-medium rounded-md hover:bg-gray-50 transition-colors shadow-sm"
        @click="writeCancel"
      >
        취소
      </button>
    </div>
  </main>
</template>

<script setup>
import { ref, reactive, onMounted, watchEffect } from "vue";
import axios from "axios";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import { quillEditor, Quill } from "vue3-quill";
import BoardHeader from "./components/boardHeader.vue";
import { BIBLE_SCHOOL_LIBRARY_BOARDS, isBibleSchoolLibraryBoard, getBibleSchoolLibraryPath } from "@/assets/js/bibleSchoolLibraryBoards.js";

import imageUploader from "quill-image-uploader";
import "quill-image-uploader/dist/quill.imageUploader.min.css";
import BlotFormatter from "quill-blot-formatter";

// import Emoji from 'quill-emoji';

Quill.register({
  "modules/imageUploader": imageUploader,
  "modules/blotFormatter": BlotFormatter,
  // 'modules/emoji': Emoji,
});

const router = useRouter();
const route = useRoute();
const store = useStore();

const tagInput = ref("");

const state = reactive({
  post: {
    postId: null,
    boardId: null,
    postTitle: "",
    postContent: "",
    isSecret: false,
    isPin: false,
    postThumbnail: null,
    postTags: [],
  },
  delToggle: false,
  attachments: [], // 첨부파일 목록 (최대 5개)
  deletedAttachmentIds: [], // 삭제된 기존 첨부파일 ID 목록
});

const boardLists = ref([
  { id: 5, name: "영유아부" },
  { id: 6, name: "유치부" },
  { id: 7, name: "유년부" },
  { id: 8, name: "초등부" },
  { id: 9, name: "청소년부" },
  { id: 10, name: "대학청년부" },
  { id: 11, name: "구역/장년" },
  { id: 12, name: "교회교육 세미나/행사안내" },
  { id: 13, name: "사역리본" },
  ...BIBLE_SCHOOL_LIBRARY_BOARDS.map((board) => ({
    id: board.id,
    name: `자료실 ${board.name}`,
  })),
]);

// 태그 추가
const addTag = (event) => {
  if (event.isComposing) return;
  const tag = tagInput.value.trim();
  if (tag && !state.post.postTags.includes(tag)) {
    state.post.postTags.push(tag);
  }
  tagInput.value = "";
};

// 태그 삭제
const removeTag = (index) => {
  state.post.postTags.splice(index, 1);
};

// 백스페이스로 태그 삭제
const handleBackspace = () => {
  if (tagInput.value === "" && state.post.postTags.length > 0) {
    state.post.postTags.pop();
  }
};

// const emojiList = ref([]);

// emojiList.value = Emoji.ShortNameEmoji.DEFAULTS.emojiList;

// const emojiMap = {};
// emojiList.value.forEach((emoji) => {
//   emojiMap[emoji.name] = emoji;
// });

// console.log(emojiMap);

const editor = reactive({
  editorOption: {
    placeholder: "내용을 입력해 주세요.",
    modules: {
      imageUploader: {
        upload: (file) => {
          return new Promise(async (resolve, reject) => {
            console.log(resolve);
            console.log(reject);
            console.log(file);

            const formData = new FormData();
            formData.append("image", file);

            const url = "/new_api/post/desc-image/new";
            await axios
              .post(url, formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              })
              .then((res) => {
                if (res.status === 200) {
                  if (res.data.code === "200") {
                    const uploadPath =
                      "https://eduwind-api.nodeblack.net" +
                      res.data.data.uploadPath;
                    resolve(uploadPath);
                  } else {
                    console.log("등록 실패");
                  }
                } else {
                  console.log("등록 실패");
                }
              })
              .catch((err) => {
                reject("Upload failed");
                console.error("Error:", err);
              });
          });
        },
      },
      blotFormatter: {
        // 이미지 리사이징 옵션
      },
    },
  },
});

const boardId = route.params.boardId;
const postId = route.params.postId;

const getPost = async () => {
  try {
    if (postId) {
      const { data } = await axios.get(`/new_api/post/${postId}`);
      state.post = data.data.post;
      // URL 변경: http://118.67.134.110:18080/ -> https://eduwind-api.nodeblack.net/
      if (state.post.postContent) {
        state.post.postContent = state.post.postContent.replace(
          /http:\/\/118\.67\.134\.110:18080\//g,
          "https://eduwind-api.nodeblack.net/",
        );
      }
      // 기존 태그가 있다면 초기화 (API 응답 구조에 따라 수정 필요할 수 있음)
      if (!state.post.postTags) {
        state.post.postTags = [];
      }
      // 기존 첨부파일 불러오기
      if (
        data.data.post.attachments &&
        Array.isArray(data.data.post.attachments)
      ) {
        state.attachments = data.data.post.attachments.map((attachment) => ({
          id: attachment.id, // 기존 첨부파일 ID
          name: attachment.fileName || attachment.name,
          size: attachment.fileSize || attachment.size,
          url: attachment.filePath || attachment.url, // 다운로드 URL
          isNew: false, // 기존 첨부파일
        }));
      }
    } else {
      // 글 작성 모드일 경우 boardId 설정
      if (boardId) {
        state.post.boardId = parseInt(boardId);
      }
      return;
    }
  } catch (err) {
    console.error(err);
  }
};

// 로그인 여부 확인
const checkAuth = () => {
  const token = localStorage.getItem("authorization");
  const accountId = store.state.account?.id;

  if (!token || !accountId) {
    alert("로그인이 필요한 서비스입니다.");
    router.push("/login");
    return false;
  }
  return true;
};

onMounted(async () => {
  // 로그인 체크
  if (!checkAuth()) {
    return;
  }

  // 성경학교 자료실은 관리자만 작성/수정 가능
  if (isBibleSchoolLibraryBoard(boardId) && store.state.level.id !== 10) {
    alert("관리자만 글을 작성할 수 있습니다.");
    router.replace(getBibleSchoolLibraryPath(boardId));
    return;
  }

  await getPost();
});

const postCreate = async () => {
  let postImageCommand = "CREATE"; // 썸네일 생성

  if (state.post.postThumbnail) {
    // 썸네일이 존재함
    const thumbnailInput = document.getElementById("thumbnailFile");

    if (thumbnailInput && thumbnailInput.files[0]) {
      // 썸네일 변경
      postImageCommand = "UPDATE";
    } else if (state.delToggle === true) {
      // 썸네일 삭제
      postImageCommand = "DELETE";
    } else {
      postImageCommand = null; // 썸네일 조작 X
    }
  }

  // URL 변경: http://118.67.134.110:18080/ -> https://eduwind-api.nodeblack.net/
  let postContent = state.post.postContent;
  if (postContent) {
    postContent = postContent.replace(
      /http:\/\/118\.67\.134\.110:18080\//g,
      "https://eduwind-api.nodeblack.net/",
    );
  }

  const jsonBody = {
    postId: state.post.postId !== null ? state.post.postId : null,
    boardId: state.post.boardId,
    postTitle: state.post.postTitle,
    postContent: postContent,
    isSecret: state.post.isSecret,
    isPin: state.post.isPin,
    postTags: state.post.postTags, // 태그 추가
    postImageCommand,
    deletedAttachmentIds: state.deletedAttachmentIds, // 삭제된 첨부파일 ID 목록
  };

  const formData = new FormData();
  formData.append("json", JSON.stringify(jsonBody));

  if (postImageCommand !== null) {
    const thumbnailInput = document.getElementById("thumbnailFile");

    if (thumbnailInput) {
      const thumbnailFile = thumbnailInput.files[0];
      formData.append("thumbnail", thumbnailFile);
    }
  }

  // 첨부파일 추가
  state.attachments.forEach((attachment) => {
    if (attachment.isNew && attachment.file) {
      formData.append("attachments", attachment.file);
    }
  });

  try {
    const res = await axios.post("/new_api/post/edit", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    console.log(res.data);

    if (res.data.code === "200") {
      const { postId } = res.data.data;
      alert("게시글이 등록되었습니다.");

      router.push(`/board/${state.post.boardId}/${postId}`);
    } else {
      res.data.reasons.forEach((reason) => {
        switch (res.data.reasons) {
          case "NotNull.boardId":
            alert("게시판을 선택해주세요.");
            break;
          case "NotNull.postTitle":
            alert("게시글 제목을 입력해 주세요.");
            break;
          case "NotNull.postContent":
            alert("게시글 내용을 입력해 주세요.");
            break;
          default:
            // 예상치 못한 이유
            alert(
              "예기치 못한 에러가 발생했습니다.\n문제 지속시 고객센터로 문의 바랍니다.",
            );
        }
      });
    }
  } catch (error) {
    console.error(error);
  }
};

// 썸네일 미리보기
const readInputFile = (e) => {
  const imagePreview = document.getElementById("imagePreview");
  imagePreview.innerHTML = "";

  const files = Array.from(e.target.files);

  files.forEach((file) => {
    if (!file.type.match("image/.*")) {
      alert("이미지 확장자만 업로드 가능합니다.");
      e.target.value = ""; // 파일 등록 취소
      return;
    }

    const reader = new FileReader();
    reader.onload = (event) => {
      const img = document.createElement("img");
      img.src = event.target.result;
      imagePreview.appendChild(img);
    };

    reader.readAsDataURL(file);
  });
};

const clearThumbnail = () => {
  // 인풋 초기화
  const thumbnailInput = document.getElementById("thumbnailFile");
  thumbnailInput.value = "";
  // 썸네일 초기화
  state.post.postThumbnail = null;
};

const writeCancel = () => {
  if (confirm("작성을 취소하시겠습니까? 작성 내용은 저장되지 않습니다.")) {
    router.go(-1); // 이전 페이지로
  }
};

watchEffect(() => {
  // 썸네일 삭제 클릭
  if (state.delToggle) {
    const confirmed = confirm("썸네일을 삭제하시겠습니까?");

    if (confirmed) {
      alert("삭제되었습니다. 게시글 등록 시 최종 적용됩니다.");

      const imagePreview = document.getElementById("imagePreview");
      imagePreview.innerHTML = "";
    } else {
      state.delToggle = false;
    }
  }
});

// 허용된 첨부파일 확장자
const ALLOWED_EXTENSIONS = [
  "pdf",
  "xls",
  "xlsx",
  "ppt",
  "pptx",
  "hwp",
  "hwpx",
  "doc",
  "docx",
  "zip",
  "jpg",
  "jpeg",
  "png",
  "gif",
];

// 파일 확장자 검증
const isAllowedExtension = (filename) => {
  const ext = filename.split(".").pop().toLowerCase();
  return ALLOWED_EXTENSIONS.includes(ext);
};

// 허용된 확장자 문자열 (안내용)
const allowedExtensionsText = ALLOWED_EXTENSIONS.join(", ");

// 첨부파일 추가
const addAttachment = (e) => {
  const files = Array.from(e.target.files);

  if (state.attachments.length + files.length > 5) {
    alert("첨부파일은 최대 5개까지 등록할 수 있습니다.");
    e.target.value = "";
    return;
  }

  files.forEach((file) => {
    // 확장자 검증
    if (!isAllowedExtension(file.name)) {
      alert(
        `${file.name}\n허용되지 않는 파일 형식입니다.\n\n허용 확장자: ${allowedExtensionsText}`,
      );
      return;
    }

    // 파일 크기 제한 (10MB)
    if (file.size > 10 * 1024 * 1024) {
      alert(`${file.name} 파일이 10MB를 초과합니다.`);
      return;
    }

    state.attachments.push({
      file: file,
      name: file.name,
      size: file.size,
      isNew: true, // 새로 추가된 파일 여부
    });
  });

  e.target.value = "";
};

// 첨부파일 삭제
const removeAttachment = (index) => {
  const attachment = state.attachments[index];

  // 기존 첨부파일인 경우 삭제 목록에 추가
  if (!attachment.isNew && attachment.id) {
    state.deletedAttachmentIds.push(attachment.id);
  }

  state.attachments.splice(index, 1);
};

// 파일 크기 포맷팅
const formatFileSize = (bytes) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};
</script>

<style>
.ql-snow .ql-editor img {
  max-width: 720px;
  height: auto;
}
.ql-editor {
  min-height: inherit;
}
</style>
